import React from "react";
import ReactDOM from "react-dom";
import { TooltipMetadata } from "../../../../uiModel/tooltip/TooltipMetadata";
import { TooltipTarget } from "../../../../uiModel/tooltip/TooltipTarget";
import { ListenerHelper } from "../../../../utils/ListenerHelper";
import { MenuButtonWithTooltipComponent } from "./MenuButtonWithTooltipComponent";

import "@styles/c-expandableMenuButton.scss";

interface Props {
  icon: React.ReactNode;
  menu: React.ReactNode;
  isActive?: boolean;
  canExpand: boolean;
  className: string;

  tooltipTarget: TooltipTarget;
  onCancelTooltip: () => void;
  onRequestTooltip: (metadata: TooltipMetadata) => void;
}

interface State {
  isExpanded: boolean;
}

export class ExpandableMenuButtonComponent extends React.Component<Props, State> {
  private button: MenuButtonWithTooltipComponent;

  constructor(props: Props) {
    super(props);
    this.state = {
      isExpanded: false,
    };
  }

  static getDerivedStateFromProps(props: Props) {
    if (!props.canExpand) {
      return {
        isExpanded: false,
      };
    } else {
      return {};
    }
  }
  render() {
    const { icon, menu, isActive, className, tooltipTarget, onCancelTooltip, onRequestTooltip } = this.props;
    return (
      <div className={`c-expandableMenuButton ${className || ""}`}>
        <MenuButtonWithTooltipComponent
          ref={(element) => (this.button = element)}
          isActive={isActive}
          onClick={() => this.toggleExpanded()}
          icon={icon}
          tooltipTarget={tooltipTarget}
          onCancelTooltip={onCancelTooltip}
          onRequestTooltip={onRequestTooltip}
          isTooltipDisabled={this.state.isExpanded}
        />
        {this.state.isExpanded && <div className="c-expandableMenuButton__menuContainer">{menu}</div>}
      </div>
    );
  }

  componentDidMount() {
    ListenerHelper.addEventListener("document", "click", this.collapseOnClickOutside);
  }

  componentWillUnmount() {
    ListenerHelper.removeEventListener("document", "click", this.collapseOnClickOutside);
  }

  private collapseOnClickOutside = (event) => {
    const buttonNode = ReactDOM.findDOMNode(this.button);
    if (!buttonNode.contains(event.target)) {
      this.setState({ isExpanded: false });
    }
  };

  private toggleExpanded() {
    const isExpanded = !this.state.isExpanded;
    if (isExpanded) {
      this.props.onCancelTooltip();
    }
    this.setState({
      isExpanded,
    });
  }
}
